module.exports = __webpack_public_path__ + "img/return.00252bb5.png";